import commonConstant from "@/constants/commonConstant";
import ApplyButton from "@/seed/components/elements/apply-button";
import CompleteStep from "@/seed/components/elements/complete-step";
import CountDown from "@/seed/components/elements/count-down";
import PurchaseForm from "@/seed/components/elements/purchase-form";
import PurchaseProgressBar from "@/seed/components/elements/purchase-progress-bar";
import PurchaseSuccess from "@/seed/components/elements/purchase-success";
import WhitelistResult from "@/seed/components/elements/whitelist-result";

import { LAYOUT_DEF } from "@/seed/constants/layout";

const TokenSaleHero = ({ data, purchaseForm, purchaseSuccess, userWallet }) => {
    console.log("TokenSaleHero", { data, purchaseForm, purchaseSuccess, userWallet });
    const renderLb0 = () => {
        if (data.content) {
            switch (data.content.layout) {
                case LAYOUT_DEF.WHITELIST_WIN:
                    return (
                        <div className="flex flex-row space-x-2">
                            <span className="uppercase font-primary">{data.content.lb0}</span>
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 46 46"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g fill="none" fillRule="evenodd">
                                    <circle fill="#A7DC68" cx="23" cy="23" r="23" />
                                    <path
                                        stroke="#FFF"
                                        strokeWidth="5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M13 21.695 20.447 30 33 16"
                                    />
                                </g>
                            </svg>
                        </div>
                    );
                    break;
                case LAYOUT_DEF.WHITELIST_FAIL:
                    return (
                        <div className="flex flex-row space-x-2">
                            <span className="uppercase font-primary">{data.content.lb0}</span>
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 27 27"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g fill="none" fillRule="evenodd">
                                    <circle fill="#F73737" cx="13.5" cy="13.5" r="13.5" />
                                    <g
                                        stroke="#FFF"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                    >
                                        <path d="m9 9 9.188 9.188M18.188 9 9 18.188" />
                                    </g>
                                </g>
                            </svg>
                        </div>
                    );
                    break;
                default:
                    return "";
                    break;
            }
        }
    };
    const renderLb1 = () => {
        if (data.content) {
            switch (data.content.layout) {
                case LAYOUT_DEF.UPCOMING:
                    return <span className="uppercase text-xl">{data.content.lb1}</span>;
                    break;
                case LAYOUT_DEF.WHITELIST_OPEN:
                case LAYOUT_DEF.WHITELIST_CLOSE:
                case LAYOUT_DEF.WHITELIST_APPLIED:
                case LAYOUT_DEF.WHITELIST_WIN:
                case LAYOUT_DEF.WHITELIST_FAIL:
                case LAYOUT_DEF.TOKEN_PURCHASE:
                case LAYOUT_DEF.TOKEN_PURCHASE_CLOSE:
                case LAYOUT_DEF.MY_ALLOCATION:
                    return (
                        <span className="uppercase text-2xl md:text-6xl">
                            {data.content.lb1}
                        </span>
                    );
                    break;
                default:
                    return (
                        <span className="uppercase text-2xl md:text-6xl">
                            {data.content.lb1}
                        </span>
                    );
                    break;
            }
        }
    };
    const renderLb2 = () => {
        if (data.content) {
            switch (data.content.layout) {
                case LAYOUT_DEF.WHITELIST_CLOSE:
                    const date = data?.saleInfo?.timeline.whitelistResultDate;
                    if (!date || isNaN(date) || data.whitelistResult) return;
                    return (
                        <p className="font-secondary w-4/5 text-center text-sm md:text-lg">
                            {data.content.lb2 + date.format(commonConstant.FORMAT_DATE_WEEKDAY)}
                        </p>
                    );

                case LAYOUT_DEF.WHITELIST_APPLIED:
                case LAYOUT_DEF.WHITELIST_FAIL:
                    return (
                        <p className="font-secondary w-4/5 text-center text-sm md:text-lg">
                            {data.content.lb2}
                        </p>
                    );
                    break;
                default:
                    return (
                        <p className="font-secondary text-center text-sm md:text-lg">
                            {data.content.lb2}
                        </p>
                    );
                    break;
            }
        }
    };
    const renderApplyBtn = () => {
        if (data.applyBtn && data.applyBtn.show) {
            return (
                <ApplyButton
                    disable={data.applyBtn.disable}
                    handleClick={() => {
                        console.log("renderApplyBtn", data?.saleInfo?.whitelistFormLink);
                        if (data?.saleInfo?.whitelistFormLink)
                            window.open(data?.saleInfo?.whitelistFormLink, "_blank").focus();
                    }}
                />
            );
        }
    };
    const renderWhitelistResult = () => {
        if (data.whitelistResult) {
            return <WhitelistResult data={data.whitelistResult} />;
        }
    };
    const renderCountDown = () => {
        if (data.countdown) {
            return (
                <CountDown
                    from={data.countdown.from}
                    to={data.countdown.to}
                    introLb={data.countdown.introLb}
                    displayFromTo={data.countdown.displayFromTo}
                    tba={data.countdown.tba}
                />
            );
        }
    };
    const renderCompletedStep = () => {
        if (data.completedStep != undefined) {
            return <CompleteStep completedStep={data.completedStep} />;
        }
    };
    const renderProgressBar = () => {
        if (data.progressBar) {
            return <PurchaseProgressBar data={data.progressBar} />;
        }
    };
    const renderPurchaseForm = () => {
        if (purchaseForm && !purchaseSuccess && userWallet) {
            return <PurchaseForm data={purchaseForm} userWallet={userWallet} />;
        }
    };
    const renderPurchaseSuccess = () => {
        if (purchaseSuccess && userWallet) {
            return <PurchaseSuccess data={purchaseSuccess} />;
        }
    };
    const renderLayout = () => {
        return (
            <div className="flex flex-col justify-center items-center text-primary font-primary space-y-[4%] landscape:space-y-[2%]">
                <div className="flex flex-col justify-center items-center space-y-[2%] lg:space-y-[3%]">
                    {renderLb0()}
                    {renderLb1()}
                    {renderLb2()}
                </div>
                {renderApplyBtn()}
                {renderWhitelistResult()}
                <div className="flex flex-col items-center justify-center space-y-[12%] landscape:space-y-[4%]">
                    {renderCountDown()}
                    {renderProgressBar()}
                    {renderPurchaseForm()}
                    {renderPurchaseSuccess()}
                    {renderCompletedStep()}
                </div>
            </div>
        );
    };
    return renderLayout();
};

export default TokenSaleHero;
